"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOutsideClick = useOutsideClick;
require("core-js/modules/web.timers.js");
var _react = require("react");
/**
 * 提供一个 DOM，在 DOM 的外部点击之后，会触发回调函数
 * @param domRefs 给定一个或多个 DOM 的 ref，在此 DOM 之外点击认为是外部点击
 * @param enabled 是否激活外部点击的处理
 * @param options 其他的配置项
 * @param isCapture 是否是事件捕获
 */
function useOutsideClick(domRefs) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timerRef = (0, _react.useRef)(null);
  var eventRef = (0, _react.useRef)(null);
  var reactEvtRef = (0, _react.useRef)(null);
  var listenerRef = (0, _react.useRef)(null);

  /**
   * 清理外部点击事件处理器
   */
  var remove = function remove() {
    listenerRef.current = null;
  };

  /**
   * 注册外部点击事件处理器
   * @param handle DOM 外部点击时的回调函数
   */
  var listen = function listen(handle) {
    listenerRef.current = function (evt) {
      var refs = !Array.isArray(domRefs) ? [domRefs] : domRefs;
      for (var i = 0; i < refs.length; i += 1) {
        var domRef = refs[i].current;
        if (domRef) {
          if (domRef.contains(evt.target)) {
            return;
          }
        }
      }
      if (options !== null && options !== void 0 && options.isCapture) {
        if (reactEvtRef.current !== evt) {
          handle(evt);
        }
      } else {
        // Portal 上模拟的冒泡事件比 DOM 事件晚
        timerRef.current = setTimeout(function () {
          if (reactEvtRef.current !== evt) {
            handle(evt);
          }
        }, 0);
      }
    };
  };

  // 在 unmount 之后，无论如何要清理
  (0, _react.useEffect)(function () {
    if (!enabled) {
      return function () {
        return null;
      };
    }
    var eventType = options !== null && options !== void 0 && options.isCapture ? 'click' : 'mousedown';
    eventRef.current = function (evt) {
      if (listenerRef.current) {
        clearTimeout(timerRef.current);
        listenerRef.current(evt);
      }
    };
    document.addEventListener(eventType, eventRef.current, options === null || options === void 0 ? void 0 : options.isCapture);
    return function () {
      remove();
      clearTimeout(timerRef.current);
      document.removeEventListener(eventType, eventRef.current, options === null || options === void 0 ? void 0 : options.isCapture);
    };
  }, [enabled]);
  return {
    listen: listen,
    remove: remove,
    // 需要忽略的组件要传入的 Props
    ignoreProps: {
      onMouseDown: function onMouseDown(evt) {
        reactEvtRef.current = evt.nativeEvent;
        return evt;
      }
    }
  };
}